var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarViewYellow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1165_13557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.16797 3.5V5.83301H3.16797V19.5H20.834V5.83301H18.834V3.5H21.5088L21.6748 3.51074C21.8392 3.52975 22 3.57353 22.1523 3.63965C22.3554 3.72779 22.5394 3.85456 22.6934 4.01367C22.8473 4.1729 22.9685 4.36137 23.0498 4.56738C23.1301 4.77094 23.1697 4.98827 23.167 5.20703H23.168V20.127H23.167C23.1696 20.3454 23.13 20.5623 23.0498 20.7656C22.9685 20.9717 22.8473 21.1601 22.6934 21.3193C22.5394 21.4785 22.3555 21.6062 22.1523 21.6943C21.9492 21.7825 21.7302 21.8293 21.5088 21.833H2.49219C2.27096 21.8293 2.0526 21.7824 1.84961 21.6943C1.64639 21.6061 1.46161 21.4786 1.30762 21.3193C1.15371 21.1601 1.03342 20.9716 0.952148 20.7656C0.87085 20.5596 0.83022 20.3397 0.833984 20.1182V5.20703C0.831322 4.98827 0.871841 4.77094 0.952148 4.56738C1.03345 4.36141 1.1537 4.17287 1.30762 4.01367C1.4616 3.85441 1.64639 3.72785 1.84961 3.63965C2.05267 3.55156 2.27087 3.50374 2.49219 3.5H5.16797Z",
    fill: "url(#paint0_linear_1165_13557)",
    stroke: "url(#paint1_linear_1165_13557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 9.33398H6.66732V10.6673H5.33398V9.33398Z",
    fill: "url(#paint2_linear_1165_13557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 9.33398H10.6673V10.6673H9.33398V9.33398Z",
    fill: "url(#paint3_linear_1165_13557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.334 9.33398H14.6673V10.6673H13.334V9.33398Z",
    fill: "url(#paint4_linear_1165_13557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.334 9.33398H18.6673V10.6673H17.334V9.33398Z",
    fill: "url(#paint5_linear_1165_13557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 12.666H6.66732V13.9993H5.33398V12.666Z",
    fill: "url(#paint6_linear_1165_13557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 12.666H10.6673V13.9993H9.33398V12.666Z",
    fill: "url(#paint7_linear_1165_13557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.334 12.666H14.6673V13.9993H13.334V12.666Z",
    fill: "url(#paint8_linear_1165_13557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.334 12.666H18.6673V13.9993H17.334V12.666Z",
    fill: "url(#paint9_linear_1165_13557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 16H6.66732V17.3333H5.33398V16Z",
    fill: "url(#paint10_linear_1165_13557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 16H10.6673V17.3333H9.33398V16Z",
    fill: "url(#paint11_linear_1165_13557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.334 16H14.6673V17.3333H13.334V16Z",
    fill: "url(#paint12_linear_1165_13557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.334 16H18.6673V17.3333H17.334V16Z",
    fill: "url(#paint13_linear_1165_13557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 6.66732C6.84348 6.66732 7.01305 6.59708 7.13807 6.47206C7.2631 6.34703 7.33333 6.17746 7.33333 6.00065V2.00065C7.33333 1.82384 7.2631 1.65427 7.13807 1.52925C7.01305 1.40422 6.84348 1.33398 6.66667 1.33398C6.48986 1.33398 6.32029 1.40422 6.19526 1.52925C6.07024 1.65427 6 1.82384 6 2.00065V6.00065C6 6.17746 6.07024 6.34703 6.19526 6.47206C6.32029 6.59708 6.48986 6.66732 6.66667 6.66732Z",
    fill: "url(#paint14_linear_1165_13557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3327 6.66732C17.5095 6.66732 17.6791 6.59708 17.8041 6.47206C17.9291 6.34703 17.9993 6.17746 17.9993 6.00065V2.00065C17.9993 1.82384 17.9291 1.65427 17.8041 1.52925C17.6791 1.40422 17.5095 1.33398 17.3327 1.33398C17.1559 1.33398 16.9863 1.40422 16.8613 1.52925C16.7363 1.65427 16.666 1.82384 16.666 2.00065V6.00065C16.666 6.17746 16.7363 6.34703 16.8613 6.47206C16.9863 6.59708 17.1559 6.66732 17.3327 6.66732Z",
    fill: "url(#paint15_linear_1165_13557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 4H15.3327V5.33333H8.66602V4Z",
    fill: "url(#paint16_linear_1165_13557)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1165_13557",
    x1: 12.0008,
    y1: 4,
    x2: 12.0008,
    y2: 21.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1165_13557",
    x1: 12.0008,
    y1: 4,
    x2: 12.0008,
    y2: 21.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1165_13557",
    x1: 6.00065,
    y1: 9.33398,
    x2: 6.00065,
    y2: 10.6673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1165_13557",
    x1: 10.0007,
    y1: 9.33398,
    x2: 10.0007,
    y2: 10.6673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1165_13557",
    x1: 14.0007,
    y1: 9.33398,
    x2: 14.0007,
    y2: 10.6673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1165_13557",
    x1: 18.0007,
    y1: 9.33398,
    x2: 18.0007,
    y2: 10.6673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1165_13557",
    x1: 6.00065,
    y1: 12.666,
    x2: 6.00065,
    y2: 13.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1165_13557",
    x1: 10.0007,
    y1: 12.666,
    x2: 10.0007,
    y2: 13.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1165_13557",
    x1: 14.0007,
    y1: 12.666,
    x2: 14.0007,
    y2: 13.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1165_13557",
    x1: 18.0007,
    y1: 12.666,
    x2: 18.0007,
    y2: 13.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1165_13557",
    x1: 6.00065,
    y1: 16,
    x2: 6.00065,
    y2: 17.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1165_13557",
    x1: 10.0007,
    y1: 16,
    x2: 10.0007,
    y2: 17.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1165_13557",
    x1: 14.0007,
    y1: 16,
    x2: 14.0007,
    y2: 17.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1165_13557",
    x1: 18.0007,
    y1: 16,
    x2: 18.0007,
    y2: 17.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1165_13557",
    x1: 6.66667,
    y1: 1.33398,
    x2: 6.66667,
    y2: 6.66732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1165_13557",
    x1: 17.3327,
    y1: 1.33398,
    x2: 17.3327,
    y2: 6.66732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1165_13557",
    x1: 11.9993,
    y1: 4,
    x2: 11.9993,
    y2: 5.33333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1165_13557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarViewYellow);
export default __webpack_public_path__ + "static/media/calendar_view_yellow.95cde26ddf767d379a4962d701f00919.svg";
export { ForwardRef as ReactComponent };